import { useSelector, shallowEqual } from "react-redux";

const useUser = () => {
  return useSelector(
    ({ applicationUser }) => ({
      userType: applicationUser?.userType,
      userName: applicationUser?.name,
      isLoggedIn: applicationUser?.isLoggedIn,
      uuid: applicationUser?.uuid,
      email: applicationUser?.mail,
      questionaireId: applicationUser?.questionaireId,
      csrfToken: applicationUser?.token,
    }),
    shallowEqual
  );
};

export default useUser;
